import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedVideo: {},
  language: "en",
  currentTab: 0,
  subTitleTemplate: {},
  color: "#000000",
  position: "top",
  subTitle: [],
  uploadedVideo: null,
  subTitleInfo: {
    fileId: null,
    taskId: null,
    videoId: null,
  },
};

const subTitleSlice = createSlice({
  name: "subtitle",
  initialState,
  reducers: {
    setSelectedVideo: (state, action) => {
      state.selectedVideo = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
    setSubTitleTemplate: (state, action) => {
      state.subTitleTemplate = action.payload;
    },
    setColor: (state, action) => {
      state.color = action.payload;
    },
    setPosition: (state, action) => {
      state.position = action.payload;
    },
    setSubTitle: (state, action) => {
      state.subTitle = action.payload;
    },
    setUploadedVideo: (state, action) => {
      state.uploadedVideo = action.payload;
    },
    setSubTitleInfo: (state, action) => {
      state.subTitleInfo = action.payload;
    },
    resetSubTitle: (state) => {
      state.selectedVideo = {};
      state.language = "en";
      state.currentTab = 0;
      state.subTitleTemplate = {};
      state.color = "#000000";
      state.position = "top";
      state.subTitle = [];
      state.uploadedVideo = null;
      state.subTitleInfo = {
        fileId: null,
        taskId: null,
        videoId: null,
      };
    },
  },
});
export const {
  setSelectedVideo,
  setLanguage,
  setCurrentTab,
  setSubTitleTemplate,
  setColor,
  setPosition,
  setSubTitle,
  setUploadedVideo,
  setSubTitleInfo,
  resetSubTitle,
} = subTitleSlice.actions;
export default subTitleSlice.reducer;
